module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Table of contents")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('p', {
    staticClass: "chap-ttl"
  }, [_c('span', {
    staticClass: "epub-bold-normal-allcaps"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('p', {
    staticClass: "bkfm-chap-ttl"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-chap-ttl-0"
  }, [_c('a', {
    attrs: {
      "href": "#/Abbreviations"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("List of abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter01"
    }
  }, [_vm._v("1  Why read Romans? Eight brief reasons")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter02"
    }
  }, [_vm._v("2  Strategies of interpretation: three essential strategies for Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter03"
    }
  }, [_vm._v("3  Nine further strategies often useful for parts of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  The reception history of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  The textual criticism and integrity of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  Paul, traveller and citizen of Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  Paul introduces himself and the theme of the gospel (1.1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  The Gentile world judged and alienated from God (1.18–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9  The Jewish world as moral critic (2.1—3.8)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  Judgement and grace on all: redemption and atonement (3.9–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  The promise of the covenant God; trust, the test case of Abraham (4.1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Peace with God (5.1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  Christ and Adam: humanity and the new humanity (5.12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14  Dead to sin; alive to God (6.1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15  Free from the condemnation of the law (7.1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16  Life characterized by the Holy Spirit’s indwelling (8.1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17  The renewal of all things: suffering and future glory (8.18–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18  Israel’s unbelief: filling a gap in Paul’s argument (9.1–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19  God’s faithfulness and Israel’s responsibility (9.30—10.21)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20  The salvation of ‘all Israel’ (11.1–36")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21  The outworking of the Christian life: sacrifice and worship  (12.1–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22  Christian obligations (13.1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23  Mutual welcome and respect: ‘the strong’ and ‘the weak’(14.1—15.13)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24  Paul’s travel plans and the coming missionary task (15.14—16.2)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25  Final greetings, final appeal and doxology (16.3–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Search items for biblical and patristic references")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Search names for modern authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Search items for subjects")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ab2b22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table_of_contents.vue
// module id = 69
// module chunks = 0